import lottie from 'lottie-web';

const designs = {
  elements: {
    figures: Array.from(document.querySelectorAll('.design-assets figure'))
  },

  init() {
    this.bindEvents();
  },

  bindEvents() {
    if(!this.elements.figures.length) return;

    this.elements.figures.forEach((figure) => this.setupFigure(figure));
  },

  async setupFigure(figure: Element) {
    const path = figure.getAttribute('data-path');
    const element = figure.querySelector('.design-assets__animation');

    if(path && element) {
      try {
        const response = await fetch(path);
        
        if (!response.ok) {
          console.warn(`Failed to fetch design animation: ${response.status} ${response.statusText}`);
          return;
        }

        // Check if response has content and is JSON
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          console.warn('Design animation response is not JSON:', contentType);
          return;
        }

        // Check if response body exists
        const text = await response.text();
        if (!text.trim()) {
          console.warn('Design animation response is empty');
          return;
        }

        // Parse JSON with error handling
        let file;
        try {
          file = JSON.parse(text);
        } catch (parseError) {
          console.error('Failed to parse design animation JSON:', parseError);
          return;
        }

        // Validate animation data structure
        if (!file || typeof file !== 'object') {
          console.warn('Invalid design animation data structure');
          return;
        }

        lottie.loadAnimation({
          container: element,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: file,
        });
      } catch (error) {
        console.error('Error loading design animation:', error);
      }
    }
  }
};

export default designs;
